export enum CommandType {
  SELECT,
  ADD,
  REMOVE,
  DUPLICATE,
  MOVE
}

export class SchemaCommand {
  static eventName = 'schema-command'
  commandType = CommandType.ADD
}

export class SelectChargeCommand extends SchemaCommand {
  schemaItemId: number
  commandType = CommandType.SELECT

  constructor(schemaItemId: number) {
    super()
    this.schemaItemId = schemaItemId
  }
}

export class AddChargeToNodeCommand extends SchemaCommand {
  schemaItemId: number
  newChargeTypeId: number
  commandType = CommandType.ADD

  constructor(schemaItemId: number, type: number) {
    super()
    this.schemaItemId = schemaItemId
    this.newChargeTypeId = type
  }
}

export class RemoveChargeToNodeCommand extends SchemaCommand {
  schemaItemIdToRemove: number
  commandType = CommandType.REMOVE

  constructor(schemaItemIdToRemove: number) {
    super()
    this.schemaItemIdToRemove = schemaItemIdToRemove
  }
}

export class DuplicateChargeCommand extends SchemaCommand {
  schemaItemIdToDuplicate: number
  commandType = CommandType.DUPLICATE

  constructor(schemaItemIdToDuplicate: number) {
    super()
    this.schemaItemIdToDuplicate = schemaItemIdToDuplicate
  }
}

export class MoveChargeCommand extends SchemaCommand {
  schemaItemIdToMove: number
  schemaItemIdTargeted: number
  commandType = CommandType.MOVE

  constructor(schemaItemIdToMove: number, schemaItemIdTargeted: number) {
    super()
    this.schemaItemIdToMove = schemaItemIdToMove
    this.schemaItemIdTargeted = schemaItemIdTargeted
  }
}
